import { IcWarning, IcBox, IcCalendar, IcSearch, IcTarget, IcBolt, IcFlame } from './icons';
import { IMode, InsightKind, FormType } from './types';

export const SLASH_COMMANDS: { id: IMode; label: string; description: string }[] = [
	{
		id: 'conversation',
		label: 'Conversation',
		description: 'Chat with the ERP AI assistant'
	},
	{
		id: 'agent',
		label: 'Agent',
		description: 'Let AI take actions in your ERP'
	},
	{
		id: 'doc_qa',
		label: 'Document',
		description: 'Upload a document and ask questions about it'
	}
];

export const INSIGHTS: {
	icon: React.FC<{ size?: number }>;
	kind: InsightKind;
	title: string;
	sub: string;
}[] = [
	{ icon: IcWarning, kind: 'red', title: 'Overdue invoices need attention', sub: 'Review receivables aging for payment follow-up' },
	{ icon: IcBox, kind: 'amber', title: 'Items below reorder level detected', sub: 'Check inventory before the next purchase order cycle' },
	{ icon: IcCalendar, kind: 'blue', title: 'Pending leave requests awaiting approval', sub: 'Some requests are past the standard SLA' }
];

export const SUGGEST_TILES: {
	icon: React.FC<{ size?: number }>;
	kind: InsightKind;
	cat: string;
	mode: IMode;
	formType?: FormType;
	prompt: string;
}[] = [
	{ icon: IcSearch, kind: '', cat: 'ASK', mode: 'conversation', prompt: 'List the 5 most recent purchase orders' },
	{ icon: IcSearch, kind: '', cat: 'ASK', mode: 'conversation', prompt: 'Show me journal entries from last month' },
	{ icon: IcBolt, kind: 'amber', cat: 'AGENT', mode: 'agent', formType: 'sales_invoice', prompt: 'Create a sales invoice' },
	{ icon: IcBolt, kind: 'amber', cat: 'AGENT', mode: 'agent', formType: 'purchase_invoice', prompt: 'Create a purchase invoice' },
	{ icon: IcSearch, kind: 'blue', cat: 'DOC', mode: 'doc_qa', prompt: 'Upload a document to get started' },
	{ icon: IcTarget, kind: 'blue', cat: 'DOC', mode: 'doc_qa', prompt: 'Ask questions about any uploaded document' },
];
